import { IAction } from "@faire/web-api--source/indigofair/data/IAction";
import { getCurrentPath } from "@faire/web/common/Path";

import {
  CONDUCTOR_MODAL_CONTENT_IDENTIFIER_QUERY_PARAM_KEY,
  OPEN_CONDUCTOR_MODAL_QUERY_PARAM_KEY,
} from "../../consts";

// the conductor_modal is driven from the query param, so we need to append the query param to the link
export const getUrlFromOpenModalAction = (sduiActions: IAction[]) => {
  const openModalAction = sduiActions.find((action) => action.open_modal);
  const conductorModalIdentifier =
    openModalAction?.open_modal?.open_conductor_modal?.conductor_token;

  if (!conductorModalIdentifier) {
    return;
  }

  return getCurrentPath()
    .append({
      [OPEN_CONDUCTOR_MODAL_QUERY_PARAM_KEY]: "1",
      [CONDUCTOR_MODAL_CONTENT_IDENTIFIER_QUERY_PARAM_KEY]:
        conductorModalIdentifier,
    })
    .toString();
};
